var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg50(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 333,
    height: 150,
    viewBox: "0 0 333 150",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M308.4 46.45L308.4 107.45L319.908 107.45C326.793 107.45 332.4 102.245 332.4 95.8526L332.4 58.0473C332.4 51.655 326.793 46.45 319.908 46.45L308.4 46.45ZM0.400024 23.8887L0.400019 130.011C0.400018 140.707 9.77554 149.45 21.2457 149.45L286.554 149.45C298.024 149.45 307.4 140.8 307.4 130.011L307.4 23.8887C307.4 13.1927 298.124 4.44995 286.554 4.44995L21.2457 4.44994C9.77554 4.44994 0.400024 13.0997 0.400024 23.8887Z",
    fill: "#BDCCD8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M308 100.45L308 42.75L319.7 42.75C326.7 42.75 332.4 48.45 332.4 55.45L332.4 87.75C332.4 94.75 326.7 100.45 319.7 100.45L308 100.45Z",
    fill: "#E4EAF0"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0.400019 121.594L0.400024 21.3059C0.400024 9.73033 9.80609 0.449938 21.3136 0.449939L287.486 0.44995C299.094 0.449951 308.4 9.83014 308.4 21.3059L308.4 121.594C308.4 133.17 298.994 142.45 287.486 142.45L21.3136 142.45C9.80609 142.45 0.400019 133.07 0.400019 121.594Z",
    fill: "#E4EAF0"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M0.800013 121.85L0.800017 21.3499C0.800018 9.74995 10.2 0.449945 21.7 0.449945L161.4 0.449951L161.4 142.75L21.8 142.75C10.2 142.75 0.800013 133.35 0.800013 121.85Z",
    fill: "#62778E"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M193.55 103C193.55 103 192.15 96.1999 183.05 88.4999C173.95 80.7999 168.05 79.3999 165.75 78.3999C163.35 77.3999 151.35 72.9999 143.55 59.3999C143.55 59.3999 150.25 76.5999 156.65 82.6999C162.65 88.3999 167.95 92.1999 172.85 93.6999C178.85 95.6999 181.15 95.0999 187.85 98.9999C190.15 100.6 193.55 103 193.55 103Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M191.05 83.8999C191.05 83.8999 190.25 77.9999 183.35 71.1999C176.35 64.3999 171.75 62.7999 169.75 61.7999C167.75 60.7999 158.45 56.4999 152.65 44.7999C152.65 44.7999 157.15 59.5999 162.05 65.1999C166.55 70.3999 170.75 73.6999 174.45 75.3999C179.25 77.3999 181.05 76.8999 186.35 80.5999C188.35 81.7999 191.05 83.8999 191.05 83.8999Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M191.05 65.9999C191.05 65.9999 191.05 61.0999 186.15 54.4999C181.15 47.8999 177.45 46.2999 175.95 45.0999C174.45 44.0999 167.15 39.3999 163.75 28.8999C163.75 28.8999 165.75 41.7999 169.25 46.8999C172.45 51.6999 175.45 54.9999 178.45 56.7999C182.25 58.9999 183.75 58.8999 187.65 62.3999C189.05 63.7999 191.05 65.9999 191.05 65.9999Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg50);
export default __webpack_public_path__ + "static/media/50.5546a1058e61e65ed688af0f86cb5ead.svg";
export { ForwardRef as ReactComponent };